import styled, { keyframes } from 'styled-components';

import { ImageButton } from 'a/components/StyledComponents';
import { ActionButton } from '../../sharedStyledComponents/Components';

export const ContinueButton = styled(ActionButton)`
  position: absolute;
  top: 393;
  left: 387;
`;

export const Background = styled.img`
  position: absolute;
  width: 672;
  height: 430;
  top: 62;
  left: 176;
`;

export const ReplacementBackground = styled.img`
  position: absolute;
  width: 672;
  height: 430;
  top: 12;
  left: 176;
`;

export const MonsterIcon = styled.img`
  position: absolute;
  top: 180;
  left: 240;
  width: 202;
  height: 210;
`;

export const Medal = styled.img`
  top: 156px;
  left: 270px;
  position: absolute;
  width: 136px;
  height: 270px;
`;

export const ModalBox = styled.img`
    position: absolute;
    top: 62px;
    left: 176px;
    object-fit: contain;
`;

export const burstRotation = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const Burst = styled.img`
  animation: ${burstRotation} 20s linear infinite;
  position: absolute;
  top: 239px;
  left: 226px;
  transform-origin: center center;
`;

export const StaticBurst = styled.img`
  position: absolute;
  width: 240;
  height: 240;
  top: 165;
  left: 230;
`;

export const Text = styled.div`
  margin: 0;
  font-family: Quicksand Medium;
  text-align: center;
`;

export const TitleText = styled(Text)`
  position: absolute;
  top: 163px;
  left: 480px;
  width: 302px;
  height: 64px;
  font-size: 27px;
  font-weight: bold;
  text-align: left;
  color: #ffffff;
`;

export const ReplacementTitleTextContainer = styled.div`
  position: absolute;
  width: 113;
  height: 34;
  top: 76;
  left: 458;
`;

export const ReplacementTitleText = styled.h2`
  margin: 0;
  text-align: center;
  font-size: 34;
  font-family: Quicksand Bold;
  color: #ffffff;
`;

export const ReplacementGreenLineDown = styled.img`
  position: absolute;
  width: 352;
  height: 17;
  top: 300;
  left: 336;
`;

export const ReplacementGreenLineUp = styled.img`
  position: absolute;
  width: 352;
  height: 17;
  top: 165;
  left: 336;
`;

export const ReplacementDescriptionText = styled.p`
  margin: 0;
  padding: 0;
  text-align: center;
  font-size: 21;
  font-family: Open Sans Semibold;
  color: #ffffff;
`;

export const ReplacementDescriptionTextContainer = styled.div`
  position: absolute;
  width: 330;
  height: 100;
  top: 196;
`;

export const DescriptionText = styled(Text)`
    top:243 ;
    left:480;
    position: absolute;
    width: 290px;
    height: 161px;
    font-size: 17px;
    font-weight: 500;
    margin-bottom: -10;
    text-align: left;
    color: #ffffff;
    opacity: 0.7;
`;

export const StyledImageButton = styled(ImageButton)`
  width: 246px;
  height: 76px;
  left: 387px;
  top: 443px;
`;

export const TitleTextContainer = styled.div`
  position: absolute;
  width: 129;
  height: 34;
  top: 132;
  left: 450;
`;

export const Title = styled.h2`
  margin: 0;
  text-align: center;
  font-size: 27;
  font-family: Quicksand;
  color: #ffffff;
`;

export const DescriptionContainer = styled.div`
  position: absolute;
  width: 302;
  height: 32;
  top: 210;
  left: 485;
`;

export const Description = styled.h3`
  margin: 0;
  text-align: left;
  font-size: 27;
  font-family: Quicksand;
  color: #ffffff;
`;

export const QuestionContainer = styled.div`
  position: absolute;
  width: 290;
  height: 80;
  top: 255;
  left: 485;
`;

export const Question = styled.p`
  padding: 0;
  margin: 0;
  opacity: 0.7;
  text-align: left;
  font-size: 17;
  font-family: Open Sans;
  color: #ffffff;
`;
